/* eslint-disable prettier/prettier */
/**
 * @fileoverview POST handler for the "/admin/impersonate" endpoint
 */
import fetch from "@lib/fetch";
import { fetchCountryCode } from "@lib/impersonation/fetchCountryCode";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { adminImpersonateCacheKeys } from "./constants";
import type { PostAdminImpersonateProps } from "./types";

export const postAdminImpersonate = reactQueryMutationAdapter(
  adminImpersonateCacheKeys,
  async (props: PostAdminImpersonateProps): Promise<any> => {
    const countryCode = await fetchCountryCode();
    return fetch("/admin/impersonate", "POST", {
      ...props,
      country_code: countryCode,
    });
  }
);
